import {Box, Button, HStack, Text} from '@chakra-ui/react';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {colors} from 'theme';

import {ProductCartControls} from './product-cart-controls/ProductCartControls';

interface Props {
  cartProduct: any;
  localQuantity: number;
  isNoStock: boolean;
  price?: number;
  oldPrice?: number | null;
  onAdd: () => void;
  onDelete: () => void;
  currentCartItemId?: string;
}

export const ModalActionBar: FC<Props> = ({
  cartProduct,
  localQuantity,
  isNoStock,
  price,
  oldPrice,
  onAdd,
  onDelete,
  currentCartItemId,
}) => {
  const {t} = useTranslation();

  if (cartProduct?.quantity) {
    return (
      <HStack spacing={5} justifyContent="space-between" w="full">
        <Box maxW="50%">
          <ProductCartControls
            isSelected
            quantity={localQuantity || cartProduct.quantity}
            massMeasurement={cartProduct.product.mass_measurement}
            onAdd={onAdd}
            onDelete={onDelete}
            cartItemId={currentCartItemId}
            isWeightProduct={cartProduct.product.is_weighted_product}
          />
        </Box>

        <Box flexDirection={['column', 'row']}>
          {cartProduct.product.old_price ? (
            <Box textAlign="center">
              <Text fontSize="16px" color={colors.textGray} textDecoration="line-through">
                {(cartProduct.product.old_price * (localQuantity || cartProduct.quantity)).toFixed(2)}
              </Text>
              <Text fontSize="20px" fontWeight="600" color={colors.pink}>
                {(cartProduct.product.price * (localQuantity || cartProduct.quantity)).toFixed(2)} {t('CURRENCY')}
              </Text>
            </Box>
          ) : (
            <Text fontSize="20px" fontWeight="600" color="gray.800">
              {(cartProduct.price * (localQuantity || cartProduct.quantity)).toFixed(2)} {t('CURRENCY')}
            </Text>
          )}
        </Box>
      </HStack>
    );
  }

  return (
    <HStack w="full">
      <Button
        w="full"
        size="lg"
        colorScheme="pink"
        disabled={isNoStock}
        borderRadius="full"
        fontWeight="bold"
        onClick={onAdd}
        fontSize={['md', 'lg']}
        sx={{WebkitTapHighlightColor: 'transparent'}}
      >
        {isNoStock ? (
          t('NOT_AVAILABLE')
        ) : oldPrice ? (
          <HStack gap={1}>
            <Text as="span" fontSize="sm" color={colors.white} textDecoration="line-through">
              {oldPrice}
            </Text>
            <Text as="span">{`${price} ${t('CURRENCY')}`}</Text>
          </HStack>
        ) : (
          `${price} ${t('CURRENCY')}`
        )}
      </Button>
    </HStack>
  );
};
